"use strict";

window.FoG = window.FoG || {};

window.FoG.Effects  = (function($) {
  function ascend(el) {
    var $el = $(el);
    $el.addClass('ascending');
    setTimeout(() => $el.addClass('ascending-endstate'), 0);
    setTimeout(() => $el.remove(), 1000);
  }
  
  return {
    ascend: ascend
  }
})(jQuery);